import { createContext, useContext, useEffect, useState } from "react";
import { UI } from "./ui";
import { CONTENT } from "./content";

export const LANGS = [
  { code: "es", label: "Español" },
  { code: "en", label: "English" },
  { code: "pt", label: "Português" },
  { code: "fr", label: "Français" },
];

const LangContext = createContext(null);

const lookup = (obj, path) => path.split(".").reduce((o, k) => o?.[k], obj);

export const LangProvider = ({ children }) => {
  const [lang, setLang] = useState(() => localStorage.getItem("alagrande_lang") || "es");

  useEffect(() => {
    localStorage.setItem("alagrande_lang", lang);
    document.documentElement.lang = lang;
  }, [lang]);

  const t = (path) => lookup(UI[lang], path) ?? lookup(UI.es, path) ?? path;
  const content = CONTENT[lang] ?? CONTENT.es;

  return (
    <LangContext.Provider value={{ lang, setLang, t, content }}>
      {children}
    </LangContext.Provider>
  );
};

export const useLang = () => useContext(LangContext);
